import { MutationResponse } from "../../domain/models/http/MutationsRequest";
import { NationalTransferMutableAttributes } from "../../domain/models/NationalTransfer";
import QueryService from "../QueryService";

class NationalTransferMutationService extends QueryService<never> {
  public constructor(baseURL: string, pathname: string) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }

  public async update(
    key: string,
    attributes: NationalTransferMutableAttributes,
  ): Promise<MutationResponse> {
    const response = await this.api.post(`${this.pathname}/mutate`, {
      mutate: [{ operation: "update", key, attributes }],
    });

    return response.data;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const nationalTransferMutationService = new NationalTransferMutationService(
  BASE_URL,
  "national_transfers",
);

export { nationalTransferMutationService };
